import { useEffect, useState } from "react";
import debounce from "lodash/debounce";

const DEBOUNCE_DELAY = 200;

export default function useWindowSizeEffect() {
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);

    const updateDimensions = debounce(() => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    }, DEBOUNCE_DELAY);

    window.addEventListener("resize", updateDimensions);

    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return {
    height,
    width
  };
}
